export default "__VITE_ASSET__CPFwphqy__"